import React from 'react';
import { Link } from 'react-router-dom';
import './inicio.css';
import images from './images';

function inicio() {
    return (
    <section>
      <section className='Inicio-carrousel'>
        <div className='Inicio-carrousel-titulo'><h1>Servicios Tecnicos</h1></div>
        <div className='Inicio-carrousel-descripcion'>
          <div className='Inicio-carrousel-descripcion-mision'><h1>NUESTRA MISIÓN</h1><br/><p>
          Ofrecer a nuestros clientes un excelente servicio con calidad a un precio competitivo en un tiempo de entrega satisfactorio.</p></div>
          <div className='Inicio-carrousel-descripcion-vision'><h1>NUESTRA VISIÓN</h1><br/><p>
          Atender toda la zona noroeste de México ayudando a nuestros clientes a cubrir sus necesidades en la industria maquiladora, talleres y público en general.</p></div>
        </div>
        <div className='Inicio-carrousel-button'><h2>Ver servicios</h2></div>
        <div className='Inicio-carrousel-groupbuttons'>
          <div className='Inicio-carrousel-groupbuttons1'><h2><Link to="/tienda">Máquina de coser</Link></h2></div>
          <div className='Inicio-carrousel-groupbuttons2'><h2><Link to="/mro">Máquina de coser</Link></h2></div>
          <div className='Inicio-carrousel-groupbuttons3'><h2><Link to="/servicio">Máquina de coser</Link></h2></div>
        </div>
      </section>
      <section className='Inicio-brands'>
        <div className='Inicio-brands-carrousel'>
          <img src={images.brand1} alt="Marca Brother" />
          <img src={images.brand2} alt="Marca Kabar" />
          <img src={images.brand3} alt="Marca Mitsubishi" />
          <img src={images.brand4} alt="Marca Hall Dielectric" />
          <img src={images.brand5} alt="Marca Juki" />
      </div>
        <div className='Inicio-brands-carrousel'>
          <img src={images.brand6} alt="Marca Efka" />
          <img src={images.brand7} alt="Marca PFAFF" />
          <img src={images.brand8} alt="Marca Union Special" />
          <img src={images.brand9} alt="Marca Durkopp Adler" />
          <img src={images.brand10} alt="Marca Callanan Industries Inc" />
        </div>
      </section>
      <section className='Inicio-decoration'>
        <div className='Inicio-decoration-titulo'>Puntadas Decorativas</div>
        <div className='Inicio-decoration-descripcion'>Máquinas Merrow para puntadas decorativas, emblemas y unidoras de lienzos</div>
        <div className='Inicio-decoration-button'><h2><Link to="/tienda">Máquina de coser</Link></h2></div>
      </section>
      <section className='Inicio-servicios'>
        <div className='Inicio-servicios-titulo'><h1>NUESTROS SERVICIOS</h1></div>
        <div className='Inicio-servicios-descripcion'><p>Descubre los mejores equipos y servicios en GIS Sewing Machine. Ofrecemos máquinas de coser industriales, repuestos de alta calidad y soporte técnico especializado para impulsar tu productividad. ¡Visita nuestra tienda y encuentra todo lo que necesitas para tu éxito!</p></div>
        <div className='Inicio-servicios-cartas'>
          <div className='Inicio-servicios-cartas-multiples'>
            <div className='Inicio-servicios-cartas-multiples-g'>
              <h2>Máquinas de coser</h2>
              <p><Link to="/tienda">Ver tienda</Link></p>
            </div>
            <div className='Inicio-servicios-cartas-multiples-g'>
              <h2>Máquinas Selladoras de RF</h2>
              <p><Link to="/tienda">Ver tienda</Link></p>
            </div>
            <div className='Inicio-servicios-cartas-multiples-g'>
              <h2>Servicio Ténico</h2>
              <p><Link to="/rf">Mas información</Link></p>
            </div>
            <div className='Inicio-servicios-cartas-multiples-g'>
              <h2>Herramientas y Refacciones</h2>
              <p><Link to="/tienda">Ver tienda</Link></p>
            </div>
          </div>
          <div className='Inicio-servicios-cartas-individuales'>
            <h2>¿No encuentras lo que buscas?</h2>
            <p>Contáctanos y nosotros te ayudamos, sin compromiso.</p>
            <button className='Inicio-servicios-cartas-individuales-b'><Link to="/tienda">Contacto</Link></button>
          </div>
        </div>
      </section>
    </section>
    );
  }
  
export default inicio;
  